import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileAlt,
  faClockRotateLeft,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import Logo from "../../assets/hafnia-logo.png";
import { authProvider } from "../../authProvider";
import { isNullOrEmpty } from "../../utils/common";
import "./Header.css";

const Header = () => {
  const [userName, setUsername] = useState("");
  const location = useLocation();

  const logout = () => {
    authProvider.logout();
  };

  useEffect(() => {
    if (isNullOrEmpty(userName)) {
      const accountInfo = authProvider.getAccountInfo();
      setUsername(accountInfo?.account?.userName || "");
    }
  }, [userName]);

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <header className="brand-header">
      <div className="brand-header__left">
        <img src={Logo} alt="Hafnia" className="brand-header__logo" />
        <span className="brand-header__title">
          Employee Request Portal
          {process.env.REACT_APP_STAGE && ` — ${process.env.REACT_APP_STAGE}`}
        </span>
      </div>

      <nav className="brand-header__nav">
        <Link
          to="/request"
          className={`brand-header__link${isActive("/request") ? " brand-header__link--active" : ""}`}
        >
          <FontAwesomeIcon icon={faFileAlt} /> Request
        </Link>
        <Link
          to="/history"
          className={`brand-header__link${isActive("/history") ? " brand-header__link--active" : ""}`}
        >
          <FontAwesomeIcon icon={faClockRotateLeft} /> History
        </Link>

        <span className="brand-header__divider" />

        <button className="brand-header__logout" onClick={logout}>
          <FontAwesomeIcon icon={faRightFromBracket} />
          Logout
          {userName && <span className="brand-header__user">({userName})</span>}
        </button>
      </nav>
    </header>
  );
};

export default Header;
